import { Container, Row, Col, Card } from "react-bootstrap";
import { Award, Users, ThumbsUp, Building } from "lucide-react";

const features = [
  {
    icon: Award,
    title: "Profissionais Certificados",
    description: "Nossa equipe é formada por especialistas com certificações reconhecidas.",
  },
  {
    icon: Users,
    title: "Atendimento Personalizado",
    description: "Cada cliente recebe atenção especial para resultados perfeitos.",
  },
  {
    icon: ThumbsUp,
    title: "Satisfação Garantida",
    description: "Nos comprometemos com sua satisfação em cada serviço.",
  },
  {
    icon: Building,
    title: "Ambiente Acolhedor",
    description: "Espaço moderno e confortável para você relaxar.",
  },
];

const AboutSection = () => {
  return (
    <section id="sobre" className="py-5 bg-muted">
      <Container className="py-5">
        <Row className="align-items-center g-5">
          {/* Left Content */}
          <Col lg={6}>
            <span className="d-inline-block text-primary-custom fw-semibold mb-3">
              Sobre Nós
            </span>
            <h2 className="display-6 fw-bold mb-4">
              Cuidando de você há mais de 5 anos
            </h2>
            <p className="text-muted-custom mb-4" style={{ lineHeight: "1.8" }}>
              Somos uma empresa dedicada a oferecer os melhores serviços de 
              beleza e bem-estar. Nossa missão é proporcionar experiências 
              únicas que elevem sua autoestima e confiança.
            </p>
            <p className="text-muted-custom mb-5" style={{ lineHeight: "1.8" }}>
              Com uma equipe altamente qualificada e um ambiente acolhedor, 
              garantimos que cada visita seja especial. Utilizamos produtos 
              de alta qualidade e técnicas modernas para resultados excepcionais.
            </p>

            {/* Stats */}
            <Row className="g-4">
              <Col xs={4}>
                <div className="fs-3 fw-bold text-primary-custom">500+</div>
                <div className="small text-muted-custom">Clientes Atendidos</div>
              </Col>
              <Col xs={4}>
                <div className="fs-3 fw-bold text-primary-custom">5+</div>
                <div className="small text-muted-custom">Anos de Experiência</div>
              </Col>
              <Col xs={4}>
                <div className="fs-3 fw-bold text-primary-custom">4.9</div>
                <div className="small text-muted-custom">Avaliação Média</div>
              </Col>
            </Row>
          </Col>

          {/* Right Content - Features Grid */}
          <Col lg={6}>
            <Row className="g-4">
              {features.map((feature, index) => (
                <Col key={index} sm={6}>
                  <Card className="card-custom shadow-card h-100 p-4">
                    <Card.Body>
                      <div className="icon-box bg-secondary-custom mb-3">
                        <feature.icon size={24} className="text-primary-custom" />
                      </div>
                      <h5 className="fw-semibold mb-2">{feature.title}</h5>
                      <p className="text-muted-custom small mb-0">{feature.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;